import { store } from "@/store";
import * as echarts from "echarts";
import {
  readLabelInfo,
  readAvgData,
} from "@/store/performance/getters";

const allChart = {}

const useChartClick = {
  data() {
    return {
      xAxisValue: '',
      cpu_freq_line: null,
      memory_detail: null,
    }
  },

  methods: {
    showClickTips(params, xAxisValue) {
      xAxisValue = xAxisValue.split('_')[0]
      const charts = [
        {chart: allChart.fps_line_chart, tipId: 'fps_line_tip'},
        {
          chart: allChart.frametime_line_chart, 
          xIndex: Math.round(this.month_new * this.chartDataFrame.rows.id_frame.length) - 1,
          tipId: 'frametime_line_tip'
        },
        {chart: allChart.cpu_usage_line_chart, tipId: 'cpu_usage_line_tip'},
        {chart: allChart.pss_line_chart, tipId: 'pss_line_tip'},
        {chart: allChart.flow_line_chart, tipId: 'flow_line_tip'},
        {chart: allChart.temp_line_chart, tipId: 'temp_line_tip'},
        {chart: allChart.cswitch_chart, tipId: 'cswitch_tip'},
        {chart: allChart.wakeups_chart, tipId: 'wakeups_tip'},
        {chart: allChart.custom_data_chart, tipId: 'custom_data_tip'},
        {chart: allChart.custom_data_second_chart, tipId: 'custom_data_second_tip'},
        {chart: allChart.cpu_core_usage_chart, tipId: 'cpu_core_usage_tip'},
        {chart: allChart.cpu_usage_normalized_chart, tipId: 'cpu_usage_normalized_tip'},
        {chart: allChart.cpu_freq_line_chart, tipId: 'cpu_freq_line_tip'},
        {chart: allChart.cpu_clock_chart, tipId: 'cpu_clock_tip'},
        {chart: allChart.memory_detail_chart, tipId: 'memory_detail_tip'},
      ]

      charts.forEach(item => {
        if (item.chart) {
          const chartOption = item.chart.getOption()
          this.showClickTip(params, chartOption, xAxisValue, item.xIndex, item.tipId)
        }
      })
    },

    showClickTip(params, chartOption, xAxisValue, xIndex, tipId) {
      const tip = document.getElementById(tipId)
      tip.style.top = `${params.offsetY + 20}px`
      tip.style.left = `${params.offsetX + 21}px`
      tip.style.display = 'block'

      const seriesData = chartOption.series
      const color = chartOption.color

      if (tipId != 'frametime_line_tip') {
        xIndex = chartOption.xAxis[0].data.findIndex(item => item == xAxisValue)
      }
      if (tipId == 'frametime_line_tip') {
        xAxisValue = chartOption.xAxis[0].data[xIndex]
      }

      const itemsHtml = seriesData.map((item, index) => {
        return `
          <div class="d-flex justify-content-between align-items-center mt-1">
            <div class="d-flex align-items-center">
              <div class="d-block rounded-circle" style="width:10px;height:10px;background: ${ item.itemStyle?.color || color?.[index] };"></div>
              <span class="ms-2">${ item.name }</span>
            </div>
            <span class="ms-4 fw-bold">${ item.data[xIndex] || '-' }</span>
          </div>
        `
      }).join('')
      tip.innerHTML = `
        <div>${ xAxisValue }</div>
        ${ itemsHtml }
      `
    },

    onChartClick(chart, xaxis) {
      let file1 = this.file;
      chart.getZr().on("click", async (params) => {
        var pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel("grid", pointInPixel)) {
          /*此处添加具体执行代码*/

          var pointInGrid = chart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );

          //X轴序号
          var xIndex = pointInGrid[0];
          const xIndex2 = pointInGrid[0]

          //获取当前图表的option
          var op = chart.getOption();

          //获得图表中我们想要的数据
          var month = op.xAxis[0].data[xIndex];
          var value = op.series[0].data[xIndex];
          const xAxisValue = xaxis[xIndex]

          xIndex = (xIndex + 1) / xaxis.length;
          this.month_new = xIndex;
          this.opacity = 1;
          this.chartSettings.dataZoom[0].start = op.dataZoom[0].start;
          this.chartSettings.dataZoom[0].end = op.dataZoom[0].end;
          await this.drawMarkLines(xAxisValue);

          // this.drawPieChartFPS();
          // this.drawPieChartFrameTime();
          // this.drawPieChartCPUUsage();
          // this.drawPieChartCPUFreq();
          // this.drawPieChartPSS();
          // this.drawPieChartMemoryDetail();
          // this.drawPieChartGPUGeneralCounter();
          // this.drawPieChartGPUMemoryCounter();
          // this.drawPieChartGPUShaderCounter();
          // this.drawPieChartFlow();
          // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
          //   this.drawPieChartCsWitch();
          //   this.drawPieChartWakeups();
          // }

          // if (this.chartDatacustom?.rows?.i?.length !== 0) {
          //   this.drawPieChartMonomem();
          //   this.drawPieChartVerts();
          //   this.drawPieChartTris();
          //   this.drawPieChartDc();
          //   this.drawPieChartGc();
          // }
          // if (this.project_id == 59) {
          //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
          //     this.drawPieChartcustom();
          //     this.drawPieChartcustomSecond()
          //   }
          // }
          
          // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
          //   this.drawPieChartMono();
          // }
          // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
          //   this.drawPieChartDrawCall();
          // }
          // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
          //   this.drawPieChartTriangle();
          // }
          // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
          //   this.drawPieChartTemp();
          // }
          // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
          //   this.drawPieChartElectric();
          // }

          // this.getPictureData();
          // this.drawPieChartCPUUsageNormalized();
          // this.drawPieChartCPUCoreUsage();
          // this.drawPieChartCPUClock();
          // this.drawAnalyseTrend();

          //this.showClickTips(params, xAxisValue, xIndex2)
        }

        let boxWidth = document.getElementById(this.pictureArr[0]?.time)
          ?.offsetWidth;

        // 获取居中平移距离
        let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

        // 将每一次平移居中位置放置每一个对象中
        this.pictureArr.forEach(function (v) {
          v.ofwidth = ofwidth -= boxWidth + 10;
          //
          //
        });
        let x = month;
        let pictureObj = this.pictureArr.filter(function (v) {
          return v.time === x;
        });

        if (pictureObj.length > 0) {
          file1 = pictureObj[0]?.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          document.getElementById(pictureObj[0].time).firstChild.style.outline =
            "6px solid #4271fb";
          let po = this.sibling1(document.getElementById(pictureObj[0].time));
          //     var siblings = sibling(document.getElementById(pictureObj[0].time));
          po.forEach(function (v) {
            //
            v.firstChild.style.outline = 0;
          });
        } else {
          let pic = this.pictureArr.filter(
            (v) => v.time === this.subtractTwoSeconds(x)
          )[0];
          file1 = pic?.ofwidth + "px";
          document.getElementById(
            "scro"
          ).style.transform = `translateX(${file1})`;
          
          let picTime = document.getElementById(pic?.time)
          if (picTime) {
            picTime.firstChild.style.outline = "6px solid #4271fb";
            let po = this.sibling1(document.getElementById(pic?.time));
            //     var siblings = sibling(document.getElementById(pictureObj[0].time));
            po.forEach(function (v) {
              if (v) v.firstChild.style.outline = 0;
            });
          }
        }
      });
    },

    drawChartMarkLine(xAxisValue, chart) {
      if (!chart) return
      const chartOption = chart.getOption()
      const xAxisData = chartOption.xAxis[0].data
      const seriesData = chartOption.series[0].data

      if (xAxisData?.length && seriesData?.length) {
        chartOption.series.forEach(item => {
          item.markLine = {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: xAxisValue,
                label: {
                  position: "end",
                  show: true,
                  formatter: xAxisValue,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  //opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          }
        })
        chart.setOption(chartOption)
      }
    },

    drawMarkLines(xAxisValue) {
      if (!xAxisValue) xAxisValue = this.xAxisValue
      xAxisValue = xAxisValue.split('_')[0]

      if (this.fps_seris_data.length > 0 && allChart.fps_line_chart) {
        const chartOption = allChart.fps_line_chart.getOption()
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue.split('_')[0],
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue.split('_')[0],
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        }

        allChart.fps_line_chart.setOption(chartOption)
      }

      if (this.cpu_usage_line_data.length > 0 && allChart.cpu_usage_line_chart) {
        const chartOption = allChart.cpu_usage_line_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.cpu_usage_line_chart.setOption(chartOption)
      }

      if (this.cpu_clock_data.length > 0 && allChart.cpu_clock_chart) {
        const chartOption = allChart.cpu_clock_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.cpu_clock_chart.setOption(chartOption)
      }

      if (this.cswitch_data?.length && allChart.cswitch_chart) {
        const chartOption = allChart.cswitch_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.cswitch_chart.setOption(chartOption)
      }

      if (this.cpu_usage_normalized_data.length > 0 && allChart.cpu_usage_normalized_chart) {
        const chartOption = allChart.cpu_usage_normalized_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.cpu_usage_normalized_chart.setOption(chartOption)
      }

      if (this.temp_line_data.length > 0 && allChart.temp_line_chart) {
        const chartOption = allChart.temp_line_chart.getOption()
        let xaxis = this.chartDataTemp.rows.timeline;

        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              //xAxis: Math.round(this.month_new * xaxis.length) - 1,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.temp_line_chart.setOption(chartOption)
      }

      if (this.pss_line_data.length > 0 && allChart.pss_line_chart) {
        const chartOption = allChart.pss_line_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.pss_line_chart.setOption(chartOption)
      }

      if (this.gpu_general_counter_data.length > 0 && allChart.gpu_general_counter_chart) {
        const chartOption = allChart.gpu_general_counter_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.gpu_general_counter_chart.setOption(chartOption)
      }

      if (this.flow_line_data.length > 0 && allChart.flow_line_chart) {
        const chartOption = allChart.flow_line_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.flow_line_chart.setOption(chartOption)
      }

      if (this.frametime_line_data.length > 0 && allChart.frametime_line_chart) {
        const chartOption = allChart.frametime_line_chart.getOption()
        let xaxis = this.chartDataFrame.rows.id_frame.map(
          (v, index) => v + "_" + String(index)
        );
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: Math.round(this.month_new * xaxis.length) - 1,
              //xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xaxis[
                  Math.round(this.month_new * xaxis.length) - 1
                ]?.split("_")[0],
                //formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.frametime_line_chart.setOption(chartOption)
      }

      if (this.gpu_memory_counter_data.length > 0 && allChart.gpu_memory_counter_chart) {
        const chartOption = allChart.gpu_memory_counter_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.gpu_memory_counter_chart.setOption(chartOption)
      }

      if (this.gpu_shader_counter_data.length > 0 && allChart.gpu_shader_counter_chart) {
        const chartOption = allChart.gpu_shader_counter_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.gpu_shader_counter_chart.setOption(chartOption)
      }

      if (this.wakeups_data.length > 0 && allChart.wakeups_chart) {
        const chartOption = allChart.wakeups_chart.getOption()
        let xaxis = this.chartDataSec.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.wakeups_chart.setOption(chartOption)
      }

      if (this.electric_line_data.length > 0 && allChart.electric_line_chart) {
        const chartOption = allChart.electric_line_chart.getOption()
        let xaxis = this.chartDataElectric.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.electric_line_chart.setOption(chartOption)
      }

      if (this.memory_detail_data.length > 0 && allChart.memory_detail_chart) {
        const chartOption = allChart.memory_detail_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.memory_detail_chart.setOption(chartOption)
      }

      if (this.cpu_freq_line_data.length > 0 && allChart.cpu_freq_line_chart) {
        const chartOption = allChart.cpu_freq_line_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.cpu_freq_line_chart.setOption(chartOption)
      }

      if (this.cpu_core_usage_data.length > 0 && allChart.cpu_core_usage_chart) {
        const chartOption = allChart.cpu_core_usage_chart.getOption()
        let xaxis = this.chartDataResult.rows.timeline;
        chartOption.series[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: true,
              xAxis: xAxisValue,
              label: {
                position: "end",
                show: true,
                formatter: xAxisValue,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity, // 设置为0，使标记线不可见
              },
            },
          ],
        };

        allChart.cpu_core_usage_chart.setOption(chartOption)
      }
      
      if (this.analyse_data.length > 0 && allChart.analyse_chart) {
        const chartOption = allChart.analyse_chart.getOption()
        let xaxis = this.cpu_by_frame.abs_times;
        if (xaxis) {
          chartOption.series[0].markLine = {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: xAxisValue,
                label: {
                  position: "end",
                  show: true,
                  formatter:xAxisValue,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          };

          allChart.analyse_chart.setOption(chartOption)
        }
      }

      if (this.custom_series_data.length > 0 && allChart.custom_data_chart) {
        const chartOption = allChart.custom_data_chart.getOption()
        let xaxis = this.chartDataCstom.rows.timeline;

        if (xaxis) {
          chartOption.series[0].markLine = {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: xAxisValue,
                label: {
                  position: "end",
                  show: true,
                  formatter: xAxisValue,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          };

          allChart.custom_data_chart.setOption(chartOption)
        }
      }

      if (this.custom_series_second_data.length > 0 && allChart.custom_data_second_chart) {
        const chartOption = allChart.custom_data_second_chart.getOption()
        let xaxis = this.chartDataCstom.rows.timeline;

        if (xaxis) {
          chartOption.series[0].markLine = {
            symbol: ["circle", "arrow"],
            data: [
              {
                silent: true,
                xAxis: xAxisValue,
                label: {
                  position: "end",
                  show: true,
                  formatter: xAxisValue,
                  color: "ED5664",
                },
                lineStyle: {
                  type: "solid",
                  color: "#ED5664",
                  width: "1",
                  opacity: this.opacity, // 设置为0，使标记线不可见
                },
              },
            ],
          };

          allChart.custom_data_second_chart.setOption(chartOption)
        }
      }

      this.drawGpuMarkLines(xAxisValue)
      this.drawChartMarkLine(xAxisValue, allChart.monomem_chart)
      this.drawChartMarkLine(xAxisValue, allChart.gc_line_chart)
      this.drawChartMarkLine(xAxisValue, allChart.dc_line_chart)
      this.drawChartMarkLine(xAxisValue, allChart.Tris_chart)
      this.drawChartMarkLine(xAxisValue, allChart.Verts_chart)
      this.drawCustomMarkLines(xAxisValue)

      this.xAxisValue = xAxisValue
    },
  }
}

const useChartZoom = {
  methods: {
    onDataZoom(chart) {
      let time = this.chartDataResult.rows.timeline;
      let labelName = this.chartDataResult.rows.label;
      let lableList3 = this.lableList3;

      chart.on("datazoom", (params) => {
        // 获取索引
        let start_rate = params.start;
        let end_rate = params.end;

        this.startValue = start_rate;
        this.endValue = end_rate;
        let start = chart.getModel().option.dataZoom[0].startValue;
        let end = chart.getModel().option.dataZoom[0].endValue;
        // if(Math.round(timeIndexEnd)===time.length){
        //   time.map((v,i)=>i>=Math.round(timeIndexStart)&& i<=Math.round(timeIndexEnd)-1)

        // }

        let arr = time.filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取labelName拉平数组
        let newLabelName = labelName.flat().filter((v, i) => {
          if (start === time.length) {
            return i >= start - 1 && i < end;
          } else {
            return i >= start && i <= end;
          }
        });

        // 获取新的lable
        var newArr = [],
          tempArr = [];
        for (var i = 0, j = newLabelName.length; i < j; i++) {
          if (newLabelName[i] == newLabelName[i + 1]) {
            tempArr.push(newLabelName[i]);
          } else {
            tempArr.push(newLabelName[i]);
            newArr.push(tempArr.slice(0));
            tempArr.length = 0;
          }
        }

        let labelWidthAll1 = [];
        let c = newArr.flat();
        let n = Array.from(new Set(c));
        let arr3 = [];

        lableList3.forEach(function (v) {
          n.forEach(function (j) {
            if (v.id_label == j) {
              arr3.push(v);
            }
          });
        });

        newArr.forEach(function (v) {
          labelWidthAll1.push((v.length / arr.length) * 100 + "%");
        });

        arr3.forEach(function (v, i) {
          labelWidthAll1.forEach(function (j, index) {
            if (i == index) {
              v.width = j;
            }
          });
        });

        this.lableList = arr3;
        this.chartSettings.dataZoom[0].start = start_rate;
        this.chartSettings.dataZoom[0].end = end_rate;

        //  this.drawPieChartCPUUsage();
        // this.drawPieChartFrameTime();
        // this.drawPieChartCPUUsage();
        // this.drawPieChartCPUFreq();
        // this.drawPieChartPSS();
        // this.drawPieChartMemoryDetail();
        // this.drawPieChartGPUGeneralCounter();
        // this.drawPieChartGPUMemoryCounter();
        // this.drawPieChartGPUShaderCounter();

        // //this.drawSmgGpuCharts()

        // this.drawPieChartFlow();
        // if (this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1) {
        //   this.drawPieChartCsWitch();
        //   this.drawPieChartWakeups();
        // }

        // if (this.chartDatacustom?.rows?.i?.length !== 0) {
        //   this.drawPieChartMonomem();
        //   this.drawPieChartVerts();
        //   this.drawPieChartTris();
        //   this.drawPieChartDc();
        //   this.drawPieChartGc();
        // }
        // if (this.project_id == 59) {
        //   if (this.chartDataCstom?.rows.timeline?.length !== 0) {
        //     this.drawPieChartcustom();
        //     this.drawPieChartcustomSecond()
        //   }
        // }
        // //
        // if (this.chartDataMonoMem?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartMono();
        // }
        // if (this.chartDataDrawCall?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartDrawCall();
        // }
        // if (this.chartDataTriangle?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTriangle();
        // }
        // if (this.chartDataTemp?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartTemp();
        // }
        // if (this.chartDataElectric?.rows?.timeline?.length !== 0) {
        //   this.drawPieChartElectric();
        // }

        // this.getPictureData();
        // this.drawPieChartCPUUsageNormalized();
        // this.drawPieChartCPUCoreUsage();
        // this.drawPieChartCPUClock();
        // this.drawAnalyseTrend();
      })
    },
  }
}

const useField = { //数据指标
  data() {
    return {
      overviewValue2: [], //概览

      selectedRow: [],
      fpsNewFields: [
        "MedRange(FPS)[%]",
        "Median(FPS)",
        "1%Low(FPS)",
        "Avg(FPS+InterFrame)",
        "Avg(FTime)",
        //"Avg(InterFrame)",
        "Jank(/10min)",
        "BigJank(/10min)",
        "SmallJank(/10min)",
        "Delta(FTime)>100ms[/h]",
        "Drop(FPS)[/h]",
        "FTime>=100[%]",
        "Smooth",
        "Std(FPS)",
        "Std(FTime)",
        "Stutter[%]",
        "Var(FTime)",
      ],
      fpsNewFieldsData: [],
      memNewFields: [
        "avg_swap",
        "avg_vss",
        "Avg(Memory)[MB]",
        "Avg(Memory+Swap)[MB]",
        //"Peak(Memory)[MB]",
        "Peak(Memory+Swap)[MB]",
      ],
      memNewFieldsData: [],
      customNewFields: [
        //"SMG-DrawCall,DrawCall",
        "SMG-FPS,FPS",
        "SMG-FrameTime,Frame",
        "SMG-FrameTime,GPU",
        "SMG-FrameTime,GT",
        "SMG-FrameTime,RHI",
        "SMG-FrameTime,RT",
        "SMG-ObjectCount,ObjectCount",
        //"SMG-Primitives,Primitives",
      ],
      customNewFieldsData: [],
      netNewFields: [
        "(Recv+Send)[KB/10min]",
        "(Recv+Send)[KB/s]",
        "Recv[KB/10min]",
        "Send[KB/10min]",
      ],
      netNewFieldsData: [],
      gpuNewFields: [
        "GPU_ALU_EFU_ALU_Fragment",
        "GPU_ALU_EFU_ALU_Vertex",
        "GPU_ALU_EFU_EFU_Fragment",
        "GPU_ALU_EFU_EFU_Vertex",
        "GPU_General_Busy",
        "GPU_General_CP_Overhead",
        "GPU_General_Clocks",
        "GPU_General_GPU_Bus_Busy",
        "GPU_Memory_Stats_Avg_Bytes_Fragment",
        "GPU_Memory_Stats_Avg_Bytes_Vertex",
        "GPU_Memory_Stats_Avg_Memory_Latency_Cycles",
        "GPU_Memory_Stats_Read_Total",
        "GPU_Memory_Stats_SP_Memory_Read",
        "GPU_Memory_Stats_Texture_Memory_Read_BW",
        "GPU_Memory_Stats_UBWC_Texture_Memory_Read_BW",
        "GPU_Memory_Stats_Write_Total",
        "GPU_Preemption_Avg_Preemption_Delay",
        "GPU_Preemption_Avg_Preemption_Restore_Time",
        "GPU_Preemption_Avg_Preemption_Save_Time",
        "GPU_Preemption_Preemptions",
        "GPU_Primitive_Processing_Average_Polygon_Area",
        "GPU_Primitive_Processing_Average_Vertices",
        "GPU_Primitive_Processing_Pre-clipped_Polygons",
        "GPU_Primitive_Processing_Prims_Clipped",
        "GPU_Primitive_Processing_Prims_Trivially_Rejected",
        "GPU_Primitive_Processing_Reused_Vertices",
        "GPU_Shader_Alloc_Time_ALUs_Working",
        "GPU_Shader_Alloc_Time_Compute",
        "GPU_Shader_Alloc_Time_EFUs_Working",
        "GPU_Shader_Alloc_Time_Shading_Fragments",
        "GPU_Shader_Alloc_Time_Shading_Vertices",
        "GPU_Shader_Precision_Fragment_ALU_Instructions_Half",
        "GPU_Shader_Precision_Fragment_EFU_Instructions",
        "GPU_Shader_Use_Shader_ALU_Capacity_Utilized",
        "GPU_Shader_Use_Shaders_Busy",
        "GPU_Stalls_Instruction_Cache_Miss",
        "GPU_Stalls_L1_Texture_Cache_Miss_Per_Pixel",
        "GPU_Stalls_Shaders_Stalled",
        "GPU_Stalls_Stalled_on_System_Memory",
        "GPU_Stalls_Texture_Fetch_Stall",
        "GPU_Stalls_Texture_L1_Miss",
        "GPU_Stalls_Texture_L2_Miss",
        "GPU_Stalls_Vertex_Fetch_Stall",
        "GPU_Texture_Filterd_Anisotropic_Filtered",
        "GPU_Texture_Filterd_Linear_Filtered",
        "GPU_Texture_Filterd_Nearest_Filtered",
        "GPU_Texture_Filterd_Texture_Pipes_Busy",
        "MAX_GPU_ALU_EFU_ALU_Fragment",
        "MAX_GPU_ALU_EFU_ALU_Vertex",
        "MAX_GPU_ALU_EFU_EFU_Fragment",
        "MAX_GPU_ALU_EFU_EFU_Vertex",
        "MAX_GPU_General_Busy",
        "MAX_GPU_General_CP_Overhead",
        "MAX_GPU_General_Clocks",
        "MAX_GPU_General_GPU_Bus_Busy",
        "MAX_GPU_Memory_Stats_Avg_Bytes_Fragment",
        "MAX_GPU_Memory_Stats_Avg_Bytes_Vertex",
        "MAX_GPU_Memory_Stats_Avg_Memory_Latency_Cycles",
        "MAX_GPU_Memory_Stats_Read_Total",
        "MAX_GPU_Memory_Stats_SP_Memory_Read",
        "MAX_GPU_Memory_Stats_Texture_Memory_Read_BW",
        "MAX_GPU_Memory_Stats_UBWC_Texture_Memory_Read_BW",
        "MAX_GPU_Memory_Stats_Write_Total",
        "MAX_GPU_Preemption_Avg_Preemption_Delay",
        "MAX_GPU_Preemption_Avg_Preemption_Restore_Time",
        "MAX_GPU_Preemption_Avg_Preemption_Save_Time",
        "MAX_GPU_Preemption_Preemptions",
        "MAX_GPU_Primitive_Processing_Average_Polygon_Area",
        "MAX_GPU_Primitive_Processing_Average_Vertices",
        "MAX_GPU_Primitive_Processing_Pre-clipped_Polygons",
        "MAX_GPU_Primitive_Processing_Prims_Clipped",
        "MAX_GPU_Primitive_Processing_Prims_Trivially_Rejected",
        "MAX_GPU_Primitive_Processing_Reused_Vertices",
        "MAX_GPU_Shader_Alloc_Time_ALUs_Working",
        "MAX_GPU_Shader_Alloc_Time_Compute",
        "MAX_GPU_Shader_Alloc_Time_EFUs_Working",
        "MAX_GPU_Shader_Alloc_Time_Shading_Fragments",
        "MAX_GPU_Shader_Alloc_Time_Shading_Vertices",
        "MAX_GPU_Shader_Precision_Fragment_ALU_Instructions_Half",
        "MAX_GPU_Shader_Precision_Fragment_EFU_Instructions",
        "MAX_GPU_Shader_Use_Shader_ALU_Capacity_Utilized",
        "MAX_GPU_Shader_Use_Shaders_Busy",
        "MAX_GPU_Stalls_Instruction_Cache_Miss",
        "MAX_GPU_Stalls_L1_Texture_Cache_Miss_Per_Pixel",
        "MAX_GPU_Stalls_Shaders_Stalled",
        "MAX_GPU_Stalls_Stalled_on_System_Memory",
        "MAX_GPU_Stalls_Texture_Fetch_Stall",
        "MAX_GPU_Stalls_Texture_L1_Miss",
        "MAX_GPU_Stalls_Texture_L2_Miss",
        "MAX_GPU_Stalls_Vertex_Fetch_Stall",
        "MAX_GPU_Texture_Filterd_Anisotropic_Filtered",
        "MAX_GPU_Texture_Filterd_Linear_Filtered",
        "MAX_GPU_Texture_Filterd_Nearest_Filtered",
        "MAX_GPU_Texture_Filterd_Texture_Pipes_Busy",
        "MAX_Shader_Processing_Fragment_Instructions",
        "MAX_Shader_Processing_Fragment_Interpolation_Instructions",
        "MAX_Shader_Processing_Fragments_Shaded",
        "MAX_Shader_Processing_Interpolation_Instructions_Fragment",
        "MAX_Shader_Processing_Textures_Fragment",
        "MAX_Shader_Processing_Textures_Vertex",
        "MAX_Shader_Processing_Vertex_Instructions",
        "MAX_Shader_Processing_Vertices_Shaded",
        "Shader_Processing_Fragment_Instructions",
        "Shader_Processing_Fragment_Interpolation_Instructions",
        "Shader_Processing_Fragments_Shaded",
        "Shader_Processing_Interpolation_Instructions_Fragment",
        "Shader_Processing_Textures_Fragment",
        "Shader_Processing_Textures_Vertex",
        "Shader_Processing_Vertex_Instructions",
        "Shader_Processing_Vertices_Shaded",
      ],
      gpuNewFieldsData: [],
    }
  },

  computed: {
    wholeValue() {
      let label = {}

      if (this.selectedRow.length == this.testInfoList.length) { //如果是全选，用AvgData
        label = readAvgData(store) 
      } else if (this.selectedRow.find(row => row.tagName == 'All')) {
        label = readLabelInfo(store)[0]
      } else if (this.selectedRow.length == 1) { //用第一个接口的数据
        const labels = readLabelInfo(store)
        label = labels.find(item => item.tagName == this.selectedRow[0].tagName)
      } else {
        label = readAvgData(store) //用第二个接口的数据
      }

      return [
        {label: 'Avg(CTemp)[°C])', value: label?.cpu_temp},
        {label: 'Avg(BTemp)[°C])', value: label?.battery_temp},
      ]
    },

    testInfo3() {
      let result = {
        date: "-",
        timestamp_start: "-",
        period: null,
        pkgname: "-",
        game_version: "-",
        tester: "-",
        device: "-",
        remark: null,
        avg_fps: "-",
        max_pss: "-",
        max_mono_used: "-",
        max_mono_total: "-",
        avg_cpu: "-",
        fps_lt_10_pcnt: "-",
        fps_lt_18_pcnt: "-",
        fps_lt_25_pcnt: "-",
        fps_lt_40_pcnt: "-",
        cpu_lt_60_pcnt: "-",
        cpu_lt_80_pcnt: "-",
        dps: "-",
        avg_dc: "-",
        max_dc: "-",
        max_triangle: "-",
        duration: "-",
        game_scene: null,
        avg_flow: "-",
        max_swap: "-",
        max_vss: "-",
        max_swap_add_pss: "-",
        lag_pcnt: "-",
        gc_freq: "-",
        gc_cnt: "-",
      }

      result = readAvgData(store)
      for (let i in result) {
        if (result === null) {
          result = "-";
        }
      }

      return result
    }
  },

  methods: {
    getFieldsData(fields, row) {
      return fields.map(field => {
        return {
          label: field,
          value: row[field]
        }
      }).filter(item => item.value)
    },

    getNewFields(tagName = 'All') {
      const row = this.testInfoList.find(item => item.tagName == tagName)

      this.fpsNewFieldsData = this.getFieldsData(this.fpsNewFields, row)
      this.memNewFieldsData = this.getFieldsData(this.memNewFields, row)
      this.customNewFieldsData = this.getFieldsData(this.customNewFields, row)
      this.netNewFieldsData = this.getFieldsData(this.netNewFields, row)
      this.gpuNewFieldsData = this.getFieldsData(this.gpuNewFields, row)
    },

    changeCustomFields() {
      if (this.selectedRow.length > 1) {
        this.getNewFields()
      } else if (this.selectedRow.length === 1) {
        const tagName = this.selectedRow[0].tagName
        this.getNewFields(tagName)
      } else {
        this.fpsNewFieldsData = []
        this.memNewFieldsData = []
        this.customNewFieldsData = []
        this.netNewFieldsData = []
        this.gpuNewFieldsData = []
      }
    },

    //概览
    getOverview2(data2, data, type) {
      if (type && this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data2 = this.testInfo3
        data = this.testInfo3
      }

      if (
        this.testInfo0.proj_name === "AOV" ||
        this.testInfo0.proj_name === "AOV测试项目" ||
        this.testInfo0.proj_name === "AOV主干Garena" ||
        this.testInfo0.proj_name === "AOV主干Tencent"
      ) {
        if (type === false) {
          this.overviewValue2 = [
            {
              label: "Avg(FPS)",
              value: data2?.avg_fps,
            },
            {
              label: "CPU<60%[%]",
              value: data2?.cpu_lt_60_pcnt,
            },
            {
              label: "Avg(AppCPU)[%]",
              value: data2?.avg_cpu,
            },
            {
              label: "Max(MonoMem)[M]",
              value: data2?.max_mono_total,
            },
            {
              label: "Used(MonoMem)[M]",
              value: data2?.max_mono_used,
            },
            {
              label: "Max(PSS)[M]",
              value: data2?.max_pss,
            },
            {
              label: "Max(Triangle)[个]",
              value: data2?.max_triangle,
            },
            {
              label: "Max(DrwaCall)[次]",
              value: data2?.max_dc,
            },
            {
              label: "卡顿率[%]",
              value: data2?.lag_pcnt,
            },
            {
              label: "Mono堆内存峰值(MB)",
              value: data2?.monomem,
            },
            {
              label: "GC次数",
              value: data2?.gc,
            },

            {
              label: "DrawCall均值",
              value: data2?.avg_dc,
            },
            {
              label: "三角形数均值",
              value: data2?.Tris,
            },
            {
              label: "顶点数均值",
              value: data2?.Verts,
            },
          ];
        } else {
          this.overviewValue2 = [
            {
              label: "Avg(FPS)",
              value: JSON.stringify(data) === "{}" ? "-" : data?.avg_fps,
            },
            {
              label: "CPU<60%[%]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_60_pcnt,
            },
            {
              label: "Avg(AppCPU)[%]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu,
            },
            {
              label: "Max(MonoMem)[M]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_mono_total,
            },
            {
              label: "Used(MonoMem)[M]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_mono_used,
            },
            {
              label: "Max(PSS)[M]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_pss,
            },
            {
              label: "Max(Triangle)[个]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_triangle,
            },
            {
              label: "Max(DrwaCall)[次]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.max_dc,
            },
            {
              label: "卡顿率[%]",
              value: JSON.stringify(data) === "{}" ? "-" : data?.lag_pcnt,
            },
            {
              label: "Mono堆内存峰值(MB)",
              value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
            },
            {
              label: "GC次数",
              value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
            },

            {
              label: "DrawCall均值",
              value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
            },
            {
              label: "三角形数均值",
              value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
            },
            {
              label: "顶点数均值",
              value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
            },
          ];
        }
      } else {
        this.overviewValue2 = [
          {
            label: "Avg(FPS)",
            value: JSON.stringify(data) === "{}" ? "-" : data?.avg_fps,
          },
          {
            label: "Jank",
            value: JSON.stringify(data) === "{}" ? "-" : data?.jank,
          },
          {
            label: "BigJank",
            value: JSON.stringify(data) === "{}" ? "-" : data?.big_jank,
          },
          {
            label: "Avg(AppCPU)[%]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu,
          },
          {
            label: "Avg(CTemp)[°C])",
            value:
              this.testInfo0.device.toUpperCase().indexOf("IPHONE") != -1
                ? "-"
                : JSON.stringify(data) === "{}"
                ? "-"
                : data?.cpu_temp,
          },
          {
            label: "Avg(BTemp)[°C])",
            value: JSON.stringify(data) === "{}" ? "-" : data?.battery_temp,
          },
          {
            label: "Avg(AppCPU)[%]Normalized",
            value:
              JSON.stringify(data) === "{}" ? "-" : data?.app_cpu_normalized,
          },
          {
            label: "CPU<=60%[%]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_60_pcnt,
          },
          {
            label: "Send[KB/s]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.send,
          },
          {
            label: "Recv[KB/s]",
            value: JSON.stringify(data) === "{}" ? "-" : data?.recv,
          },
        ];

        if (
          this.testInfo0.proj_name === "CF手游" ||
          this.testInfo0.proj_name === "CFM手游测试"
        ) {
          this.overviewValue2.push(
            {
              label: "Max(MonoMem)[M]",
              value: data2?.max_mono_total,
            },
            {
              label: "Used(MonoMem)[M]",
              value: data2?.max_mono_used,
            },
            {
              label: "Max(PSS)[M]",
              value: data2?.max_pss,
            },
            {
              label: "Max(Triangle)[个]",
              value: data2?.max_triangle,
            },
            {
              label: "Max(DrwaCall)[次]",
              value: data2?.max_dc,
            },
            {
              label: "卡顿率[%]",
              value: data2?.lag_pcnt,
            },
            {
              label: "Mono堆内存峰值(MB)",
              value: data2?.monomem,
            },
            {
              label: "GC次数",
              value: data2?.gc,
            },
            {
              label: "DrawCall均值",
              value: data2?.avg_dc,
            },
            {
              label: "三角形数均值",
              value: data2?.Tris,
            },
            {
              label: "顶点数均值",
              value: data2?.Verts,
            }
          );
        }
        if (this.testInfo0.proj_name === "QQ飞车手游") {
          this.overviewValue2.push(
            {
              label: "CPU0功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_0,
            },
            {
              label: "CPU1功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_1,
            },
            {
              label: "CPU2功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_2,
            },
            {
              label: "CPU3功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_3,
            },
            {
              label: "CPU4功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_4,
            },
            {
              label: "CPU5功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_5,
            },
            {
              label: "CPU6功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_6,
            },
            {
              label: "CPU7功耗",
              value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_power_7,
            }
          );
        }
      }
    },

    //FPS
    getFPSValue(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }

      this.FPSValue = [
        {
          label: "Avg(FPS)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_fps,
        },
        {
          label: "Var(FPS)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.var_fps,
        },
        {
          label: "FPS<=10[%]",
          value: this.ChangeFPS?.lteFPS,
        },
        {
          label: "FPS>=25[%]",
          value: this.ChangeFPS?.gteFPS,
        },
        {
          label: "FPS>=18[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.fps_lt_18_pcnt,
        },
        {
          label: "FPS>=40[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.fps_lt_40_pcnt,
        },
        {
          label: "Jank",
          value: JSON.stringify(data) === "{}" ? "-" : data?.jank,
        },
        {
          label: "BigJank",
          value: JSON.stringify(data) === "{}" ? "-" : data?.big_jank,
        },
        {
          label: "Stutter[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.lag_pcnt,
        },
        {
          label: "Avg(InterFrame)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.inter_frame,
        },
        // {
        //   label: "GC次数[次]",
        //   value: this.testInfo?.gc_cnt,
        // },
        // {
        //   label: "GC频率[次/分]",
        //   value: this.testInfo?.gc_freq,
        // },
      ];
    },

    //CPU
    getCPUValue(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }

      this.CPUValue = [
        {
          label: "Avg(Process CPU)[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu,
        },
        {
          label: "Avg(Total CPU)[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_cpu_total,
        },
        {
          label: "CPU<=60[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_60_pcnt,
        },
        {
          label: "CPU<=80[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_lt_80_pcnt,
        },
        {
          label: "Avg(CTemp)[°C])",
          value: JSON.stringify(data) === "{}" ? "-" : data?.cpu_temp,
        },
        {
          label: "Avg(AppCPU)[%]Normalized",
          value: JSON.stringify(data) === "{}" ? "-" : data?.app_cpu_normalized,
        },
        {
          label: "Avg(TotalCPU)[%]Normalized",
          value:
            JSON.stringify(data) === "{}" ? "-" : data?.total_cpu_normalized,
        },
      ];
    },

    //Memory
    getMemoryValue(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }

      this.MemoryValue = [
        {
          label: "Avg(Memory)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_pss,
        },
        {
          label: "Peak(Memory)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.max_pss,
        },
        {
          label: "Avg(SwapMemory)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_swap,
        },
        {
          label: "Peak(SwapMemory)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.max_swap,
        },
        {
          label: "Avg(VirtualMemory)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_vss,
        },
        {
          label: "Peak(VirtualMemory)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.max_vss,
        },
        {
          label: "Avg(AvailableMemory)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.available_memory,
        },
        {
          label: "Peak(AvailableMemory)[MB]",
          value:
            JSON.stringify(data) === "{}" ? "-" : data?.max_available_memory,
        },
        {
          label: "Avg(NativePss)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.native_pss,
        },
        {
          label: "Avg(Gfx)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.gfx,
        },
        {
          label: "Avg(GL)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.gl,
        },
        {
          label: "Avg(JavaHeap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.java_heap,
        },
        {
          label: "Avg(Unknown)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.unknown,
        },
        {
          label: "Avg(DalvikHeap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.dalvik_heap,
        },
        {
          label: "Avg(DalvikOther)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.dalvik_other,
        },
        {
          label: "Avg(Stack)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.stack,
        },
        {
          label: "Avg(Cursor)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.cursor,
        },
        {
          label: "Avg(Ashmem)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.ashmem,
        },
        {
          label: "Avg(OtherDev)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.other_dev,
        },
        {
          label: "Avg(.so mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.so_mmap,
        },
        {
          label: "Avg(.jar mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.jar_mmap,
        },
        {
          label: "Avg(.apk mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.apk_mmap,
        },
        {
          label: "Avg(.ttf mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.ttf_mmap,
        },
        {
          label: "Avg(.dex mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.dex_mmap,
        },
        {
          label: "Avg(Other mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.other_mmap,
        },
        {
          label: "Avg(.oat mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.oat_mmap,
        },
        {
          label: "Avg(.art mmap)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.art_mmap,
        },
        {
          label: "Avg(EGL mtrack)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.egl_mtrack,
        },
        {
          label: "Avg(Other mtrack)[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.other_mtrack,
        },
      ];
    },

    //GPU
    getGPUValue(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }

      let result = [
        {
          label: "GpuBusBusy[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.gpu_bus_busy,
        },
        {
          label: "ShadersBusy[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.shaders_busy,
        },
        {
          label: "PreClippedPolygons[K]",
          value:
            JSON.stringify(data) === "{}" ? "-" : data?.pre_clipped_polygons,
        },
        {
          label: "ReadTotal[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.read_total,
        },
        {
          label: "WriteTotal[MB]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.write_total,
        },
        {
          label: "TextureL2Miss[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.texturel2miss,
        },
        {
          label: "StalledOnSystemMemory[%]",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data?.stalled_on_system_memory,
        },
        {
          label: "VerticesShaded[K]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.vertices_shaded,
        },
        {
          label: "FragmentsShaded[K]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.fragments_shaded,
        },
        {
          label: "GUsage[%]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.gpu_usage,
        },
        {
          label: "GClock[MHz]",
          value:
            data.custom_data == null ||
            data.custom_data == undefined ||
            data.custom_data == "-"
              ? "-"
              : JSON.parse(data.custom_data)?.GClock,
        },
      ];
      
      if (this.testInfo0.device_type == 1) {
        this.GPUValue = [
          {
            label: "Device",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Device,
          },
          {
            label: "Render",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Render,
          },
          {
            label: "Tiler",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Tiler,
          },
          ...result
        ]
      } else {
        this.GPUValue = result
      }
    },

    //NetWork
    getNetWorkValue(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }

      this.NetWorkValue = [
        {
          label: "DPS[KB/s]",
          value:
            this.testInfo2.custom_data !== "-"
              ? JSON.parse(this.testInfo2.custom_data)?.DPS
              : JSON.stringify(data) === "{}"
              ? "-"
              : data?.dps,
        },
        {
          label: "Send[KB/s]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.send,
        },
        {
          label: "Recv[KB/s]",
          value: JSON.stringify(data) === "{}" ? "-" : data?.recv,
        },
        // {
        //   label: "进程上行流量[KB/s]",
        //   value: this.testInfo?.process_up_flow,
        // },
        // {
        //   label: "进程下行流量[KB/s]",
        //   value: this.testInfo?.process_down_flow,
        // },
        // {
        //   label: "逻辑上行流量[KB/s]",
        //   value: this.testInfo?.logic_up_flow,
        // },
        // {
        //   label: "逻辑下行流量[KB/s]",
        //   value: this.testInfo?.logic_down_flow,
        // },
      ];
    },

    //custom
    getCustom(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }

      this.custom = [
        {
          label: "Mono堆内存峰值(MB)",
          value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
        },
        {
          label: "GC次数",
          value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
        },
        {
          label: "DrawCall均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
        },
        {
          label: "三角形数均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
        },
        {
          label: "顶点数均值",
          value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
        },
      ];
      if (
        this.testInfo0.proj_name === "CF手游" ||
        this.testInfo0.proj_name === "CFM手游测试"
      ) {
        this.custom = [
          {
            label: "Mono堆内存峰值(MB)",
            value: JSON.stringify(data) === "{}" ? "-" : data?.monomem,
          },
          {
            label: "GC次数",
            value: JSON.stringify(data) === "{}" ? "-" : data?.gc,
          },
          {
            label: "DrawCall均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.avg_dc,
          },
          {
            label: "三角形数均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Tris,
          },
          {
            label: "顶点数均值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.Verts,
          },
          {
            label: "DrawCall最大值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.max_dc,
          },
          {
            label: "三角形数最大值",
            value: JSON.stringify(data) === "{}" ? "-" : data?.max_triangle,
          },
          {
            label: "顶点数最大值",
            value:
              JSON.stringify(data) === "{}"
                ? "-"
                : data.custom_data
                ? JSON.parse(data.custom_data)?.max_vertices
                : "-",
          },
        ];
      }
    },

    //自定义数据
    getCustomValue(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }

      let list = ["SMG-DrawCall,DrawCall", "SMG-Primitives,Primitives"];
      let data_cus = [];
      list.forEach((v) => {
        data_cus.push({
          label: v,
          value: JSON.stringify(data) === "{}" ? "-" : data[v],
        });
      });
      this.CustomValue = data_cus;
    },

    getCsWitch(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }
      this.CswitchValue = [
        {
          label: "Avg(CSwitch)",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data.custom_data == null ||
                data.custom_data == undefined ||
                data.custom_data == "-"
              ? ""
              : JSON.parse(data.custom_data)?.CSwitch
              ? JSON.parse(data.custom_data)?.CSwitch
              : "-",
        },
      ];
    },

    getWakeups(data) {
      if (this.selectedRow.length === this.testInfoList.length) { //如果选择标签的时候是全选，使用testInfo3的数据
        data = this.testInfo3
      }
      this.WakeupsValue = [
        {
          label: "Avg(Wakeups)",
          value:
            JSON.stringify(data) === "{}"
              ? "-"
              : data.custom_data == null ||
                data.custom_data == undefined ||
                data.custom_data == "-"
              ? ""
              : JSON.parse(data.custom_data)?.Wakeups
              ? JSON.parse(data.custom_data)?.Wakeups
              : "-",
        },
      ];
    },
  }
}

const useFps = {
  methods: {
    drawPieChartFPS() {
      let fps_line = document.getElementById("fps_line");
      if (fps_line.getAttribute("style") === "display:none") {
        fps_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(fps_line);

      let FPSLineChart = echarts.init(fps_line);
      let option;
      this.onDataZoom(FPSLineChart)

      option = {
        title: {
          text: "FPS",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data:
            this.chartDataResult.rows.timeline.length !== 0
              ? this.chartDataResult.rows.timeline
              : this.chartDataFPS.rows.timeline,
        },
        series: this.fps_seris_data,
      };
      FPSLineChart.setOption(option);

      let xaxis =
            this.chartDataResult.rows.timeline.length !== 0
              ? this.chartDataResult.rows.timeline
              : this.chartDataFPS.rows.timeline;
      this.judgNull(option.series, fps_line);
      allChart.fps_line_chart = FPSLineChart
      this.onChartClick(FPSLineChart, xaxis)

      return FPSLineChart;
    },
  }
}

const useGpu = {
  methods: {
    drawGpuMarkLines(xAxisValue) {
      this.drawChartMarkLine(xAxisValue, allChart.gpu_device_chart)
      this.drawChartMarkLine(xAxisValue, allChart.gpu_render_chart)
      this.drawChartMarkLine(xAxisValue, allChart.gpu_tiler_chart)
    },

    drawSmgGpuChart(domId, titleText) {
      const seriesData = this.chartDataSec.rows[titleText]
      if (this.isEmpty(seriesData)) return

      let chartDom = document.getElementById(domId)
      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(chartDom);

      let lineChart = echarts.init(chartDom)
      this.onDataZoom(lineChart)

      const xAxisData = this.chartDataSec.rows.timeline
      const series = [
        {
          name: titleText,
          data: seriesData,
          type: "line",
          showSymbol: false,
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {},
        }
      ]
      let option = {
        title: {
          text: titleText,
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData,
        },
        series
      }
      lineChart.setOption(option)
      
      //this.judgNull(option.series, fps_line)
      allChart[`${domId}_chart`] = lineChart
      this.onChartClick(lineChart, xAxisData)
    },

    drawSmgGpuCharts() {
      if (this.project_id == 59 && this.testInfo0.device_type == 1) {
        this.drawSmgGpuChart('gpu_device', 'Device')
        this.drawSmgGpuChart('gpu_render', 'Render')
        this.drawSmgGpuChart('gpu_tiler', 'Tiler')
      }
    }
  }
}

const useCustom = {
  methods: {
    drawCustomMarkLines(xAxisValue) {
      this.drawChartMarkLine(xAxisValue, allChart.custom_data_chart)
      this.drawChartMarkLine(xAxisValue, allChart.custom_data_second_chart)
      this.drawChartMarkLine(xAxisValue, allChart.custom_smg_fps_chart)
      this.drawChartMarkLine(xAxisValue, allChart.custom_smg_frame_chart)
    },

    drawChartCustom() {
      this.drawChartCustom2()
      this.drawChartCustom3()
    },

    drawChartCustom2() {
      let fps_line = document.getElementById("custom_smg_fps");
      if (fps_line.getAttribute("style") === "display:none") {
        fps_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(fps_line);

      let FPSLineChart = echarts.init(fps_line);
      allChart.custom_smg_fps_chart = FPSLineChart
      this.onChartClick(FPSLineChart, this.chartDataCstom.rows.timeline)

      let option;
      //this.onDataZoom(FPSLineChart)

      option = {
        title: {
          text: "SMG-FPS,FPS",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataCstom.rows.timeline,
        },
        series: [{
          name: "SMG-FPS,FPS",
          type: "line",
          showSymbol: false,
          data: this.chartDataCstom.rows["SMG-FPS,FPS"],
          itemStyle: this.chartSettings.itemStyle2,
          markLine: {}
        }],
      };
      FPSLineChart.setOption(option);
      this.judgNull(option.series, fps_line);
      
      return FPSLineChart;
    },

    drawChartCustom3() {
      let fps_line = document.getElementById("custom_smg_frame");
      if (fps_line.getAttribute("style") === "display:none") {
        fps_line.setAttribute("style", "width: 100%; height: 400px");
      }

      // 用echarts时，如果存在DOM，就会报存在警告，处理方法删除DOM
      // echarts数据变动时, 数据正常，图标混乱，故以此解决
      echarts.dispose(fps_line);

      let FPSLineChart = echarts.init(fps_line);
      allChart.custom_smg_frame_chart = FPSLineChart
      this.onChartClick(FPSLineChart, this.chartDataCstom.rows.timeline)

      let option;
      //this.onDataZoom(FPSLineChart)

      const series = ['SMG-FrameTime,Frame', 'SMG-FrameTime,GPU', 'SMG-FrameTime,GT', 'SMG-FrameTime,RHI', 'SMG-FrameTime,RT'].map(item => ({
        name: item,
        type: "line",
        showSymbol: false,
        data: this.chartDataCstom.rows[item],
        itemStyle: this.chartSettings.itemStyle2,
        markLine: {}
      }))
      option = {
        title: {
          text: "SMG-FrameTime",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartDataCstom.rows.timeline,
        },
        series,
      };
      FPSLineChart.setOption(option);
      this.judgNull(option.series, fps_line);
      
      return FPSLineChart;
    }
  }
}

const useTest = {
  data() {
    return {
      testChart2: null,
    }
  },

  mounted() {
    this.drawTest()
  },

  methods: {
    drawTest() {
      var chartDom = document.getElementById('test-chart');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [150, 230, null, 218, null, 147, 260],
            type: 'line',
            markLine: {
              symbol: ["circle", "arrow"],
              data: [
                {
                  silent: true,
                  xAxis: 2,
                  label: {
                    position: "end",
                    show: true,
                    formatter: '230',
                    color: "ED5664",
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#ED5664",
                    width: "1",
                    opacity: this.opacity, // 设置为0，使标记线不可见
                  },
                },
              ],
            },
          }
        ]
      };

      myChart.setOption(option);
      //this.testChart2 = myChart

     
    }
  }
}

//点击和框选功能
const useRect = {
  data() {
    return {
      isDrawing: false,
      startX: null,
      startXValue: null,
      endXValue: null,
      visibleClickLine: false,
      clickLineLeft: null,
      curClickPoint: {newData: {}, oldData: {}},
      visibleRect: false,
      rectLeft: 0,
      rectWidth: 0,
      curIndex: null,
      rectInfo: {},
    }
  },

  methods: {
    getAvgFps(curFpsRange) {
      let sum = 0
      for (let i = 0; i < curFpsRange.length; i++) {
        sum += curFpsRange[i]
      }

      return (sum / curFpsRange.length).toFixed(1)
    },

    getAvgFrameTime(curFrameTimeRange) {
      let sum = 0
      for (let i = 0; i < curFrameTimeRange.length; i++) {
        sum += curFrameTimeRange[i]
      }

      return (sum / curFrameTimeRange.length).toFixed(1)
    },

    getRectInfo() {
      const curRange = this.chartData?.new?.slice(this.startXValue, this.endXValue + 1) || [],
        curFpsRange = curRange.map(item => item.fps),
        curFrameTimeRange = curRange.map(item => item.frame_time),
        avgFps = this.getAvgFps(curFpsRange),
        minFps = Math.min(...curFpsRange),
        fps18 = ((curFpsRange.filter(item => item >= 18).length / curFpsRange.length) * 100).toFixed(1) + '%',
        fps25 = ((curFpsRange.filter(item => item >= 25).length / curFpsRange.length) * 100).toFixed(1) + '%',
        avgFrameTime = this.getAvgFrameTime(curFrameTimeRange),
        maxFrameTime = Math.max(...curFrameTimeRange),
        frameTime100 = ((curFrameTimeRange.filter(item => item >= 100).length / curFrameTimeRange.length) * 100).toFixed(1) + '%',
        frameTime40 = ((curFrameTimeRange.filter(item => item >= 40).length / curFrameTimeRange.length) * 100).toFixed(1) + '%'

      this.rectInfo = {avgFps, minFps, fps18, fps25, avgFrameTime, maxFrameTime, frameTime100, frameTime40}
    },

    getXAxisValue(myChart, offsetX, offsetY) {
      //获取 ECharts 实例的坐标系转换器
      var pointInPixel = [offsetX, offsetY];
      var pointInGrid = myChart.convertFromPixel('grid', pointInPixel);

      //获取 x 轴的值
      var xAxisValue = pointInGrid[0];
      return xAxisValue;
    },

    onMouseEvent(myChart) {
      let startXValue = null

      //监听 mousedown 事件
      myChart.getZr().on('mousedown', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY] //获取点击的 触发点像素坐标
        
        if (myChart.containPixel('grid', pointInPixel)) { //判断给定的点是否在指定的坐标系或者系列上
          this.isDrawing = true
          this.rectInfo = {}
          this.startX = params.offsetX
          const xAxisValue = this.getXAxisValue(myChart, params.offsetX, params.offsetY)
          this.startXValue = startXValue = xAxisValue
        }
      })
     
      myChart.getZr().on('mousemove', (params) => {
        if (!this.isDrawing) return
        
        const pointInPixel = [params.offsetX, params.offsetY] //获取点击的 触发点像素坐标
        if (myChart.containPixel('grid', pointInPixel)) { //判断给定的点是否在指定的坐标系或者系列上
          const xAxisValue = this.getXAxisValue(myChart, params.offsetX, params.offsetY)
          
          if (params.offsetX - this.startX >= 0) {
            this.rectLeft = this.startX
            this.rectWidth = params.offsetX - this.startX
            this.startXValue = startXValue
            this.endXValue = xAxisValue
          } else {
            this.rectLeft = params.offsetX
            this.rectWidth = this.startX - params.offsetX
            this.startXValue = xAxisValue
            this.endXValue = startXValue
          }

          this.visibleRect = true
          this.visibleClickLine = false
        } else { //鼠标超出grid区域时停止框选
          this.isDrawing = false
        }
      })
      
      //监听 mouseup 事件
      myChart.getZr().on('mouseup', (params) => {
        if (!this.isDrawing) return
        const pointInPixel = [params.offsetX, params.offsetY] //获取点击的 触发点像素坐标
        if (myChart.containPixel('grid', pointInPixel)) { //判断给定的点是否在指定的坐标系或者系列上
          this.isDrawing = false
          const xAxisValue = this.getXAxisValue(myChart, params.offsetX, params.offsetY)
          this.endXValue = params.offsetX - this.startX >= 0 ? xAxisValue : startXValue

          if (this.startXValue === this.endXValue) return
          //处理框选
          //this.getRectInfo()
          this.isMultiFrame = true
        }
      })
    },

    registerAllMouseEvent() {
      Object.values(allChart).forEach(chart => this.onMouseEvent(chart))
    },

    showClickLine(index, param) {
      this.visibleRect = false
      this.visibleClickLine = true
      this.clickLineLeft = param.offsetX
      this.curClickPoint = {
        index,
        newData: this.chartData.new[index] || {},
        oldData: this.chartData.old[index] || {},
      }
    },
  }
}

export {allChart, useChartClick, useChartZoom, useField, useFps, useGpu, useCustom, useRect}